import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { AuthService } from '../../../services/auth.service';
import { SearchService } from '../../../services/search.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
	private readonly notifier: NotifierService;
	userDetail: any = [];
	librarySetting:any=[];
	accountHistory:any = null;
  listSize:number = 20;
  currentOffset:number = 0;
  totalCount:number = 0;
	responseAPIstatus:boolean = false;
  dateFormat:string = "M/d/yyyy";
  sortWith: string = "author";
  descendingWith: any;
  viewRefresh = true;
  historydata: any;
  facets: any;
  facetsInformation: any[];
  pagesCount: any[];
  sortBy: string= '';
  lazyRequeat: boolean;
  infiniteScroll: boolean;
  orderBy:string = 'asc'
  constructor(@Inject(DOCUMENT) private document: Document, private authService: AuthService, private searchService: SearchService, private homepageService: HomepageService, private router: Router, private cookieService: CookieService,notifierService: NotifierService, private activatedRoute: ActivatedRoute)
  {
  	this.notifier = notifierService;
  }

  ngOnInit() {
  	this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('list');
    this.librarySetting  = this.homepageService.getUpdatedConfig();      
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      //this.userDetail = JSON.parse(this.cookieService.get( 'info')).detail;
      this.userDetail = JSON.parse(localStorage.getItem('info')).detail;
    	this.getAccountHistory(this.listSize, this.currentOffset, this.sortBy, this.orderBy);      	
    } else {
    	this.notifier.notify( 'error', 'Please login to see circulation history.');
    	//this.router.navigate(['/']);
    }
    this.activatedRoute.queryParams.subscribe(params => {
      if (typeof (params.facets) != 'undefined' && params.facets != '') {
        var tempFactes = params.facets.split(",");
        for (var i = 0; i < tempFactes.length; i++) {
          var index = this.facets.indexOf(parseInt(tempFactes[i]));
          if (index < 0) {
            this.facets.push(parseInt(tempFactes[i]));
          }
        }
      }
      if (typeof (params.order) != 'undefined' && params.order != '') {
        this.sortWith = params.order;
      }
    });
  }

  imageError1(event,images){
    //console.log(event)
    if(typeof($('body').find('img[custom="'+event+'"]').attr('index')) != 'undefined' &&  parseInt($('body').find('img[custom="'+event+'"]').attr('index')) > 0 ){
      var index:number = parseInt($('body').find('img[custom="'+event+'"]').attr('index'));
      if(typeof($('body').find('img[custom="'+event+'"]').attr('loaded')) != 'undefined')
      index--;
      this.imageLoad1(event, images,index, true);
    } else {
      $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('img[custom="'+event+'"]').remove();          
    }
  }

  imageLoad1(event, images,index, fromError = false) {
    if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes' && !fromError) {
      return false;
    }
    if($('body').find('#'+event).length <= 0) {
       $('body').append('<img id="'+event+'" src="" style="display:none;">');
    }
    var $this = this;
    var sources = ['OL','GB','MR','PQ','CM'];
    //var sizes = ['xxs','xs','s','m','l','xl'];
    var sizes = ['xl','l','m','s','xs','xxs'];
    var imagesAll = [];
    sources.forEach((src)=>{
      sizes.forEach((evt) => {
        images.forEach((img) => {
          if(img.sizeAsString == evt && img.sourceAsString == src){
            imagesAll.push(img.url);
          }
        });
      });
    });
    //console.log(imagesAll);
    $('#'+event).attr('src',imagesAll[index]);
    setTimeout(function(){
      var tempWidth = $('#'+event).width();
      var temp = document.getElementById(event);
      if(tempWidth <= 1 && index > 0){
        $this.imageLoad1(event,images,index-1, true);
        return false;
      }else if(tempWidth <= 1 && index == 0){
        $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('img[custom="'+event+'"]').remove();
      }
    },500);
    if(typeof(imagesAll[index]) != 'undefined') {
      $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[index]);
      $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
      $('body').find('img[custom="'+event+'"]').attr('index',index);        
    }
  }

  getAccountHistory(listSize, currentOffset, sortBy, order){
    if(!sortBy)
    sortBy= this.sortWith;
    this.viewRefresh = false;
    
    this.dateFormat = this.homepageService.formatDate();
  	var token = localStorage.getItem('token');
  	this.homepageService.getAccountHistory(token,listSize,currentOffset, sortBy, order).subscribe((data:any) => {
  		this.responseAPIstatus = true;
  		if(!data.status){
  			this.notifier.notify( 'error', data.message);
  			this.router.navigate(['/']);
        this.viewRefresh = false;
  		} else {
        if(this.accountHistory != null){
          data.data.records.forEach((evt) => {
            this.accountHistory.data.records.push(evt);
          });
        }
        else{
          this.accountHistory = data;
          this.totalCount = data.data.totalCount;
        }
        if(data.data.totalCount > 20 && currentOffset < data.data.totalCount){
          this.currentOffset += listSize;
        }
  		}
      this.viewRefresh = false;
  	},
  	(error) => {
        this.responseAPIstatus = true;
        this.notifier.notify( 'error', "Something went wrong.");
      // }
  	});
  }
  
 
  getListSort(sortBy, offset, order) {
    var token = localStorage.getItem('token');
    this.viewRefresh = true;
    this.currentOffset = offset;
    if(this.sortWith == sortBy){
      if(this.orderBy == 'asc'){
        this.orderBy = 'desc';
      }else{
        this.orderBy = 'asc';
      }
    }
    if(sortBy){
      this.sortWith = sortBy;
      this.currentOffset = 0;
    }
    return this.homepageService.getAccountHistory(token, this.listSize, offset, this.sortWith, this.orderBy).subscribe((data) => {
      this.accountHistory = data;
      this.viewRefresh = false;
      this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: {
            order: this.sortWith,
          },
          queryParamsHandling: "merge"
        }
      )
    });
    

  }

  lazyLoading(currentOffset,listSize){
    if(currentOffset < this.totalCount ){
    var offset = (currentOffset + listSize);
    if (this.lazyRequeat == true || this.infiniteScroll === false || this.totalCount < currentOffset) {
       return false;
    }
    this.lazyRequeat = true;
    //if (this.totalCount > offset) {
      this.lazyRequeat = true;
      this.getAccountHistory(listSize, offset, this.sortWith, this.orderBy);
    }
    this.lazyRequeat = false;
    this.viewRefresh = false;
    this.currentOffset = offset;
  }

  updateFacets(facets) {
    this.facetsInformation = [];
    facets.forEach((facets) => {
      var facetsData = [];
     
      if (facetsData[0]) {
        var temp = {};
        temp['key'] = facets.key;
        temp['caption'] = facets.caption;
        temp['selectedId'] = facets.selectedId;
        temp['selectedValue'] = facets.selectedValue;
        temp['listOrder'] = facets.listOrder;
        temp['values'] = facetsData;
        this.facetsInformation.push(temp);
      }
    });
  }
  //Counting page.
  createRange(number) {
    var items: any[] = [];
    for (var i = 0; i < number; i++) {
      items.push(i);
    }
    this.pagesCount = items;
  }

}


